import React, { useState } from "react";
import { DatePicker, Form, Input, Select, Spin } from "antd";
import moment from "moment";
import { useQuery } from "react-query";
import { AxiosAreasAPI } from "../Api";
import { useDebouncedSearch } from "../../utils/Hooks";
import {
  DynamicCol,
  GutteredRow,
} from "../../common/components/AreasPositions/Grid";
import { maxValueRule } from "../../utils/input";

const AreaAddForm = ({ form }) => {
  const [, debouncedSearch, setSearch] = useDebouncedSearch();
  const [isSearching, setIsSearching] = useState(true);

  const { Option } = Select;

  const { data: areas } = useQuery(
    ["areas", debouncedSearch],
    () => AxiosAreasAPI.getAll({ search: debouncedSearch }, {}),
    { onSettled: () => setIsSearching(false) },
  );

  return (
    <Form layout={"vertical"} form={form}>
      <GutteredRow>
        <DynamicCol>
          <Form.Item
            label="Nome da Área:"
            name="name"
            rules={[
              { required: true, message: "Por favor insira o nome da área." },
              maxValueRule(200),
            ]}
          >
            <Input />
          </Form.Item>
        </DynamicCol>
        <DynamicCol>
          <Form.Item
            label="Código:"
            name="code"
            rules={[
              { required: true, message: "Por favor insira o código da área." },
              maxValueRule(50),
            ]}
          >
            <Input />
          </Form.Item>
        </DynamicCol>
      </GutteredRow>
      <GutteredRow>
        <DynamicCol>
          <Form.Item label="Área pai:" name="parent_area">
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              onSearch={(value) => {
                setSearch(value);
                setIsSearching(true);
              }}
              notFoundContent={
                isSearching ? (
                  <Spin size={"small"} />
                ) : (
                  "Nenhuma área encontrada"
                )
              }
            >
              {!isSearching &&
                areas?.results.map((area) => (
                  <Option key={area.id} value={area.id}>
                    {area.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </DynamicCol>
        <DynamicCol>
          <Form.Item
            label="Data de criação"
            name="start_date"
            initialValue={moment(new Date())}
            rules={[
              {
                required: true,
                message: "Por favor insira a data de criação.",
              },
            ]}
          >
            <DatePicker
              placeholder={"Selecione uma data"}
              format={"DD/MM/YYYY"}
            />
          </Form.Item>
        </DynamicCol>
      </GutteredRow>
    </Form>
  );
};

export default AreaAddForm;
